
import React, { useState } from "react";

import { ListGroupItem } from 'reactstrap';

import { FaArrowDown } from "react-icons/fa";

import "../../../assets/css/StyleSheet.css";



export default function GeneralWork() {
    window.document.title = "Trabaja-con-nosotros"

    return (
        <>
            <div
                className="page-header section-dark"
                style={{
                    backgroundColor: "#8A8A8A"
                }} />

            <style>
                {".page-header {height: 80px; min-height: unset}"}
            </style>

            <div className="CardGroup-Work-us">
                <iframe className="Iframe-Work" id="Iframe-Work" name="preselect" src="https://oiprocesos.epreselec.com/Ofertas/Ofertas.aspx?id_idioma=1&id_origen=web+corporativa"
                    style={{ width: "100%", height: "700px", frameborder: "0" }}></iframe>

            </div>
            <div className="List-Work">
                <h1>Preguntas frecuentes: </h1>
                <List title={"Cómo enviar el CV"} content={<p>
                    Si quieres dejarnos tu CV, accede al apartado Trabaja con Nosotros. Aquí tienes publicadas todas las ofertas de empleo activas en cada una de nuestras soluciones de negocio.
                        También puedes aplicar a nuestras ofertas a través de infojobs en el siguiente link:<a href="https://oiprocesos.epreselec.com/Ofertas/Ofertas.aspx?id_idioma=1&id_origen=web+corporativa">  https://oiprocesos </a>
                        Si entre las ofertas que tenemos activas, no encuentras tu puesto ideal, déjanos tu CV a través del siguiente link: <a href="https://oiprocesos.epreselec.com?id_idioma=1&id_origen=Intranet"> https://oiprocesos.epreselec.com </a> y te avisaremos cuando tengamos ofertas de empleo que encajen con tu perfil.
                    </p>} />
                <List title={"Cómo darme de baja"} content={<p>
                    Conservar tus datos en InfoJobs, te puede ser muy útil si en el futuro quieres volver a buscar trabajo, así no tendrás que volver a rellenar toda tu información. Además, si tu CV está en InfoJobs, aunque no estés buscando trabajo,
                    éste estará disponible para las empresas que buscan candidatos como tú.Quizá un día recibes una oferta muy interesante por parte de una empresa.
                    <br />
                    <br />
                            Por favor dirígete a la sección <a href="https://www.infojobs.net/candidate/candidate-login/candidate-login.xhtml?dgv=8468427940786498280">Ajustes</a>, allí encontrarás el apartado Darme de baja. Podrás escoger entre:
                    <br />
                    <br />
                            Dejar de recibir emails con ofertas de empleo
                            Eliminar todas mis candidaturas de las ofertas donde me he inscrito anteriormente
                            Ocultar mi CV a las empresas que buscan candidatos en InfoJobs
                            Si no quieres ninguna opción anterior y prefieres darte de baja, eliminando definitivamente todos tus datos de InfoJobs, podrás hacerlo haciendo clic en el botón [Quiero darme de baja].
                    <br />
                    <br />
                            ¿Tienes algún problema con el proceso de baja? Nosotros podemos realizarlo por ti si nos envías este <a href="https://media.infojobs.net/portales/ij/app/docs/formulario-solicitud-baja.pdf">formulario</a> cumplimentado.
                    </p>} />
                <List title={"Olvidé la contraseña"} content={<p>
                    Accede <a href="https://accounts.infojobs.net/security/accounts/recovery/index-responsive.xhtml?j_clientId=empleo_ij">aquí</a> para recuperar la contraseña, sólo tienes que poner el correo electrónico con el que te diste de alta
                    </p>} />
                <List title={"¿Contactarán conmigo en cuanto mi solicitud les haya llegado?"} content={<p>
                    Cuando recibamos tu CV, te enviaremos un email confirmándote que lo hemos recibido correctamente
                    </p>} />
                <List title={"¿También ofrecen puestos de prácticas?"} content={<p>
                    Ofrecemos también puestos de prácticas. Puedes acceder  a nuestras ofertas de prácticas a través del apartado “trabaja con nosotros” o a través de infojobs: <a href="https://oiprocesos.admin.epreselec.com">  https://oiprocesos.admin.epreselec.com </a>.
                        También puedes enviarnos tu Curriculum a través del siguiente link: <a href="https://oiprocesos.epreselec.com?id_idioma=1&id_origen=Intranet"> https://oiprocesos.epreselec.com </a>, y cuando dispongamos de ofertas de prácticas en las que puedieras encajar, contactaremos contigo.
                    </p>} />
                <List title={"¿Durante cuánto tiempo se conservarán los datos de mi solicitud de empleo en la base de datos?"} content={<p>
                    Los datos se conservarán durante seis meses desde el inicio de sesión más reciente, de conformidad con las normas de protección de datos. Dicho plazo comenzará de nuevo en el momento en que vuelva
                    a iniciar sesión y revise su perfil. Antes de que finalice el periodo de seis meses, recibirá una notificación por correo electrónico, con la antelación suficiente, para avisarle de que se va a proceder a
                    eliminar su perfil si no vuelve a iniciar sesión.
                    </p>} />
                <List title={"Estoy interesado en varios puestos. ¿Basta con enviar solo una solicitud de empleo?"} content={<p>
                    Con que te inscribas en una de las ofertas de empleo que te interesen, tu CV quedará ya registrado en nuetra BBDD.
                    </p>} />

            </div>
        </>
    );
}

function List(props) {

    const [open, setOpen] = useState(false);

    return (
        <>
            <ListGroupItem onClick={() => setOpen(!open)} tag="a"><FaArrowDown className="Icons-Work" />{props.title}</ListGroupItem>

            {open && props.content}
        </>
    );
}